/** A point of the chart, a null or undefined value is a gap in the data */
type ChartPoint = { x: number | null; y: number | null | undefined };

/**
 * Grade between two chart points in %, null when it can't be computed
 * (a point without a value, e.g. a gap in the data, or two points at the same distance)
 */
export const getElevationGrade = (
  currentChartPoint: ChartPoint,
  prevChartPoint: ChartPoint
) => {
  const { x: currentX, y: currentY } = currentChartPoint;
  const { x: prevX, y: prevY } = prevChartPoint;
  if (currentX === null || prevX === null) return null;
  if (currentY === null || currentY === undefined) return null;
  if (prevY === null || prevY === undefined) return null;
  if (currentX === prevX) return null;

  return ((currentY - prevY) / ((currentX - prevX) * 1000)) * 100;
};
